import React from "react";
import "./CategoryCard.css";
import { Link } from "react-router-dom";

const scrollToTop1 = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const CategoryCard = ({ category }) => (
  <div className="category-card">
    <Link
      to={`${
        category.id === 1
          ? "/category1"
          : category.id === 2
          ? "/category2"
          : "/category3"
      }`}
      onClick={scrollToTop1}
    >
      {" "}
      <img
        src={category.image}
        alt={category.name}
        className="category-card__image"
      />
    </Link>
    <div className="category-card__name">{category.name}</div>
  </div>
);

export default CategoryCard;
